import script from "./CardParceiro.vue?vue&type=script&setup=true&lang=js"
export * from "./CardParceiro.vue?vue&type=script&setup=true&lang=js"

import "./CardParceiro.vue?vue&type=style&index=0&id=3c2910fc&scoped=true&lang=scss"
import "./CardParceiro.vue?vue&type=style&index=1&id=3c2910fc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c2910fc"]])

export default __exports__